import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import type { State } from 'state';
import { completeSignup } from 'state/actions/complete-signup';

import { getSignupToken, getPortalId, getIsSubmitting, getSubmitError } from 'state/selectors/complete-signup';
import { getContactLink } from 'state/selectors/env';
import { withBrowserMetricsScreenTransitionStatus } from '@atlassian/help-center-common-util/analytics/browsermetrics-screen-transition-status-context';
import CompleteSignupFormComponent from './complete-signup-form';

const selector = createSelector(
    (state: State) => getSignupToken(state),
    (state: State) => getPortalId(state),
    (state: State) => getIsSubmitting(state),
    (state: State) => getSubmitError(state),
    (state: State) => getContactLink(state),
    (signupToken, portalId, isSubmitting, submitError, contactLink) => ({
        signupToken,
        portalId,
        isSubmitting,
        submitError,
        contactLink,
    })
);

export default connect(selector, {
    completeSignupAction: completeSignup,
})(withBrowserMetricsScreenTransitionStatus(CompleteSignupFormComponent));
